module.exports = __webpack_public_path__ + "static/media/group.e796f0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/group.png
// module id = 1274
// module chunks = 0